module.exports = __webpack_public_path__ + "static/media/logo-sgu-white.8574e2b5.png";